import React from 'react';
import { toast } from "react-toastify";
import { FileDownloadOutlined } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { Controller, useForm } from "react-hook-form";

import AppConfirmDialog from "components/Shared/AppConfirmDialog";
import AppForm from "components/Shared/AppForm";
import DateRangeToggle from "components/Shared/DateRangeToggle";

import { useLazyListCustomerQuery } from "store/services/customerApi";

import { exportExcelFile } from "utils/exportExcelFile";

import moment from "moment";

const EXCEL_DATA_INITIAL_STATE = {
  dateRange: [],
};

const ExportCustomerExcel = ({ isBusy = false }) => {
  const [showDialog, setShowDialog] = React.useState(false);
  const { control, handleSubmit, reset } = useForm({
    defaultValues: EXCEL_DATA_INITIAL_STATE,
  });
  const [fetchCustomers] = useLazyListCustomerQuery();

  const handleDownload = async (data) => {
    const { dateRange } = data;
    const fromDate = moment(dateRange[0]).format("MM-DD-YYYY");
    const toDate = moment(dateRange[1]).format("MM-DD-YYYY");

    const payload = {
      fromDate,
      toDate,
    };

    try {
      const responseData = await fetchCustomers(payload).unwrap();

      if (!responseData?.data || responseData.data.length === 0) {
        toast.info("No customer records found for the selected date range.");
        return;
      }

      const formattedData = responseData?.data.map((row, index) => ({
        SN: index + 1,
        "Customer ID": row.customerID || "N/A",
        "Name": row.customerUserName || row.profileName || "N/A",
        "Email": row.email || "N/A",
        "Phone": row.phone || "N/A",
        "Address": row.address || "N/A",
      }));

      exportExcelFile({ sheetData: formattedData, fileName: "CustomerList" });
    } catch (error) {
      toast.error("Error fetching customer data: " + error.message);
    }
    handleReset();
  };

  const handleReset = () => {
    setShowDialog(false);
    reset(EXCEL_DATA_INITIAL_STATE);
  };

  return (
    <>
      <Tooltip title="Download Excel" arrow>
        <IconButton color="success" onClick={() => setShowDialog(true)}>
          <FileDownloadOutlined />
        </IconButton>
      </Tooltip>
      <AppConfirmDialog
        open={showDialog}
        onClose={handleReset}
        onConfirm={handleSubmit(handleDownload)}
        title="Download Customer Excel"
        dialogIcon={() => <FileDownloadOutlined color="success" />}
      >
        <AppForm loading={isBusy}>
          <AppForm.Content>
            <Controller
              name="dateRange"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <DateRangeToggle {...field} label="Select Date Range" />
              )}
            />
          </AppForm.Content>
        </AppForm>
      </AppConfirmDialog>
    </>
  );
};

export default ExportCustomerExcel;